import React, { createContext, useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const ChannelsFilterContext = createContext(null);

export function ChannelsFilterProvider({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const assistantIdParam = searchParams.get('assistant_id');
  const assistantId = assistantIdParam ? parseInt(assistantIdParam, 10) : null;
  const validAssistantId = Number.isFinite(assistantId) ? assistantId : null;

  const clearAssistantFilter = () => {
    const next = new URLSearchParams(searchParams);
    next.delete('assistant_id');
    next.delete('action');
    setSearchParams(next, { replace: true });
  };

  const value = useMemo(
    () => ({
      assistantId: validAssistantId,
      clearAssistantFilter,
    }),
    [validAssistantId, searchParams, setSearchParams]
  );

  return (
    <ChannelsFilterContext.Provider value={value}>
      {children}
    </ChannelsFilterContext.Provider>
  );
}

export function useChannelsFilter() {
  return useContext(ChannelsFilterContext);
}
